var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C8.68629 3 6 5.68629 6 9C6 11.3233 6.86366 13.6467 10.9988 13.9634C11.5495 14.0056 11.9195 14.4473 11.6287 14.9168C10.9217 16.0583 9.3221 17.7744 7.85865 19.225C7.21093 19.867 7.66331 20.9368 8.55906 20.7654C15.1367 19.5067 18 13.439 18 8.81371C18 5.5 15.3137 3 12 3Z",
    fill: "#735CE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C9.51472 4.5 7.5 6.51472 7.5 9C7.5 10.0077 7.69294 10.7663 8.11744 11.2939C8.51281 11.7853 9.31617 12.3301 11.1134 12.4678C11.733 12.5153 12.4132 12.7987 12.8485 13.4061C13.3423 14.0951 13.3536 14.9806 12.9039 15.7066C12.3969 16.5253 11.5359 17.5451 10.6087 18.5449C14.6397 16.6667 16.5 12.3482 16.5 8.81371C16.5 6.38972 14.5479 4.5 12 4.5ZM7.85865 19.225C9.3221 17.7744 10.9217 16.0583 11.6287 14.9168C11.9195 14.4473 11.5495 14.0056 10.9988 13.9634C6.86366 13.6467 6 11.3233 6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.5 18 8.81371C18 13.439 15.1367 19.5067 8.55906 20.7654C7.66331 20.9368 7.21093 19.867 7.85865 19.225Z",
    fill: "#735CE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleQuote);
export default __webpack_public_path__ + "static/media/single-quote.24611499.svg";
export { ForwardRef as ReactComponent };